import { useRuntime } from "./useRuntime";
var join = function(baseUrl, path) {
    var delimiter = path.indexOf("/") === 0 ? "" : "/";
    return "".concat(baseUrl).concat(delimiter).concat(path);
};
export var useAccountConfig = function() {
    var ref = useRuntime(), _account = ref.account, apiBaseUrl = _account.apiBaseUrl, sessionBaseUrl = _account.sessionBaseUrl;
    return {
        formatApiUrl: function formatApiUrl(path) {
            return join(apiBaseUrl, path);
        },
        formatSessionUrl: function formatSessionUrl(path) {
            return join(sessionBaseUrl, path);
        }
    };
};
